import React, { useEffect, useState, useContext } from 'react';
import ls from 'local-storage';
import ExcelJS from 'exceljs';
import {
  CButton,
  CCard,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CCol
} from '@coreui/react';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { bulkDailyRecap } from 'src/services/Transactions';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
function BulkDailyRecap() {
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');
  const [bdr, setBDR] = useState([]);
  const [trxRows, setTrxRows] = useState([]);
  const [trxColumns, setTrxColumns] = useState([]);
  const [excelRows, setExcelRows] = useState([]);
  const [excelColumns, setExcelColumns] = useState([]);

  const Auth = useContext(AuthContext);
  const navigate = useNavigate();
  const { height, width, comparison } = useWindowDimensions();

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);
  const handlerClickDownloadButton = async ({ dateFrom, dateTo }) => {
    const workbook = new ExcelJS.Workbook();
    bdr &&
      bdr.map((item, i) => {
        workbook.addWorksheet(item.merchantName, {
          headerFooter: {
            firstHeader: 'Hello Exceljs',
            firstFooter: 'Hello World'
          }
        });
        const worksheet = workbook.getWorksheet(item.merchantName);

        const config = { width: '10' };

        worksheet.columns = [
          { header: 'No', key: 'no', width: '5' },
          ...trxColumns.map((item) => {
            return { header: item.headerName, key: item.field, ...config };
          })
        ];

        item.dailyRecap &&
          item.dailyRecap.map((x, i) => {
            console.log(x);
            let tableRows = {
              no: i + 1,
              merchantID: x.merchant_id,
              boothID: x.booth_id,
              merchantName: x.merchantName,
              gross: x?.gross,
              discount: x?.discount,
              timeout: x.timeout,
              revenue: x?.revenue,
              prints: x.prints,
              reprints: x.reprints,
              grossReprints: x?.gross_reprint,
              date: formatter('longDate', x?.day ?? '0000-00-00'),
              happyHour: x.is_happy_hour
            };
            return worksheet.addRow(tableRows);
          });
      });

    const uint8Array = await workbook.xlsx.writeBuffer();
    const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    let fileName = 'Bulk Daily Recap' + ' ' + dateFrom + ' sampai ' + dateTo + '.xlsx';
    a.href = url;
    a.download = fileName;
    a.click();
    a.remove();
  };
  async function fetchBulkDailyRecap(dateFrom, dateTo, id) {
    setLoading(true);
    const res = await bulkDailyRecap(dateFrom, dateTo, id ?? '');
    setBDR(res.data);

    const columns = [
      { field: 'date', headerName: 'Date', width: '200' },
      { field: 'boothID', headerName: 'Booth ID', width: '100' },
      { field: 'merchantName', headerName: 'Merchant', width: '200' },
      { field: 'prints', headerName: 'Trx Prints', width: '150' },
      { field: 'reprints', headerName: 'Reprints', width: '150' },
      { field: 'timeout', headerName: 'Timeout', width: '100' },
      { field: 'happyHour', headerName: 'Happy Hour', width: '100' },
      { field: 'gross', headerName: 'Gross', width: '150' },
      { field: 'grossReprints', headerName: 'Gross Reprint', width: '150' },
      { field: 'discount', headerName: 'Discount', width: '150' },
      { field: 'revenue', headerName: 'Revenue', width: '150' }
    ];

    setTrxColumns(columns);
    setTableLoading(false);
    setLoading(false);
  }

  useEffect(() => {
    setTableLoading(true);
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);

    fetchBulkDailyRecap(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
    setRefetch(false);
    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal]);

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  return (
    <div style={{ color: 'black' }}>
      <CRow>
        <CCol></CCol>
        <CCol>{/* <BoothPicker /> */}</CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>

      {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
        <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw' }}>
          <CCol xs="3">Bulk Daily Recap: </CCol>
          <CCol xs="9" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CButton
              className="ml-3 mb-3 btn btn-dark"
              style={{ backgroundColor: '#4E5B97', border: 'none' }}
              hover="true"
              onClick={() => {
                setDrModal(!drModal);
              }}
            >
              <div>
                {Moment(dateRange[0].startDate).format('ll')}
                {' - '}
                {Moment(dateRange[0].endDate).format('ll')}
              </div>
            </CButton>
            &emsp;
            {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
              <CButton
                // disabled={.length === 0 ? true : false}
                disabled={loading ? true : false}
                onClick={(e) =>
                  handlerClickDownloadButton({
                    dateFrom: formatter('SQLDate', dateRange[0].startDate),
                    dateTo: formatter('SQLDate', dateRange[0].endDate)
                  })
                }
                style={{ backgroundColor: '#4E5B97', border: 'none' }}
              >
                {loading ? 'loading' : 'Download'}
              </CButton>
            )}
          </CCol>
        </CHeader>
      )}
    </div>
  );
}

export default BulkDailyRecap;
